export default __webpack_public_path__ + "static/media/Our-Workflow.75d15762.png";